var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.247,
    height: 20.241,
    viewBox: "0 0 20.247 20.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.999 12.153a.7.7 0 0 0-1.194.51.7.7 0 0 0 .211.493l7.037 6.889a.721.721 0 0 0 .994-.01.7.7 0 0 0-.011-.993z",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.945 7.936a.717.717 0 0 0 .994 0 .7.7 0 0 0 0-.992L1.2.205a.702.702 0 1 0-.994.992z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.545 0a.7.7 0 0 0-.5.2L.203 19.043a.7.7 0 0 0 0 .992.716.716 0 0 0 .994 0L20.039 1.192a.7.7 0 0 0-.5-1.2z",
    "data-name": "Path 19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.ff75b044.svg";
export { ForwardRef as ReactComponent };